import { Vue } from '~/utils/nuxt3-migration'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)
